(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["memys-social-proof"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('memys-social-proof')) {
    customElements.define('memys-social-proof', class extends HTMLElement {
      connectedCallback() {
        const widget = this.querySelector('.memys-social-proof__widget');
        if (!widget) return;
        const update = () => {
          const data = widget.querySelector('[data-number-of-reviews][data-score]');
          const count = Number(data?.getAttribute('data-number-of-reviews'));
          const score = Number(data?.getAttribute('data-score'));
          widget.hidden = !(Number.isFinite(count) && count > 0 && Number.isFinite(score) && score > 0 && score <= 5);
        };
        update();
        this.observer = new MutationObserver(update);
        this.observer.observe(widget, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-number-of-reviews', 'data-score'] });
      }
      disconnectedCallback() { this.observer?.disconnect(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["memys-wholesale-home"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('memys-wholesale-home')) {
  customElements.define('memys-wholesale-home', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      this.querySelector('.mwh-quote')?.addEventListener('click', event => {
        if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        event.stopPropagation();
        window.location.assign(event.currentTarget.href);
      }, {signal: this.controller.signal});
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["memys-wholesale-v2"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('memys-wholesale-v2')) {
  customElements.define('memys-wholesale-v2', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.abort = new AbortController();
      this.labels = JSON.parse(this.querySelector('[data-labels]').textContent);
      this.form = this.querySelector('form');
      this.message = this.querySelector('[data-message]');
      this.contactPanel = this.querySelector('[data-contact-panel]');
      this.families = {industrial:['white','color'],libres:['white','color','campo']};
      this.formats = [['segunda',180],['primera',180],['extra',180],['super',100],['super',180],['jumbo',100]];
      this.message.name = 'contact[Consulta]'; this.message.required=false;
      this.bodyField = this.querySelector('[data-generated-body]') || document.createElement('input');
      this.bodyField.type = 'hidden'; this.bodyField.name = 'contact[body]'; this.bodyField.dataset.generatedBody=''; this.form.append(this.bodyField);
      this.renderFamilies();
      this.querySelector('[data-enhanced]').hidden = false;
      this.contactPanel.hidden = true;
      this.form.noValidate = false;
      this.listen(this.querySelector('[data-submit]'),'click',e=>{if(this.submitting||!this.validateInquiry()){e.preventDefault();return;}this.refresh();this.save();});
      this.listen(this.form,'keydown',e=>{if(e.key==='Enter'&&e.target.matches('input:not([type=radio]):not([type=checkbox])')){e.preventDefault();this.querySelector('[data-submit]').click();}});
      this.listen(this, 'input', e => { if(e.target.setCustomValidity)e.target.setCustomValidity(''); this.querySelector('[data-query-error]').hidden=true; this.refresh(); this.save(); });
      this.listen(this, 'change', () => { this.refresh(); this.save(); });
      this.listen(this.querySelector('[data-open-form]'), 'click', () => this.openForm(true));
      this.listen(this.querySelector('[data-clear]'), 'click', () => {this.querySelectorAll('[data-line],[data-variety],[data-calibre]').forEach(e=>e.checked=false);this.querySelectorAll('[data-quantity]').forEach(e=>e.value='');this.querySelector('[data-volume][value=undefined]').checked=true;this.refresh();this.save();});
      this.querySelectorAll('[data-jump]').forEach(a=>this.listen(a,'click',e=>{e.preventDefault();this.querySelector('.mw2-consult').scrollIntoView({behavior:'auto',block:'start'});this.message.focus({preventScroll:true});}));
      this.querySelectorAll('[data-wa]').forEach(a=>this.listen(a,'click',e=>{if(!this.validQuantities()){e.preventDefault();return;}this.refresh();this.save();}));
      this.listen(this.form,'submit',e=>this.submit(e));
      this.listen(window,'pageshow',e=>{if(e.persisted)this.resetSubmit();});
      const success=this.querySelector('[data-success]');
      if(success){this.clearSaved();this.querySelectorAll('[data-contact]').forEach(e=>e.value='');this.message.value='';success.focus();const url=new URL(location.href);url.searchParams.delete('contact_posted');history.replaceState(history.state,'',url);}
      else this.restore();
      this.querySelectorAll('[data-new]').forEach(b=>this.listen(b,'click',()=>{success.hidden=true;this.message.focus();}));
      if(this.querySelector('[data-server-error]')){this.openForm(false);this.querySelector('[data-server-error]').focus();}
      this.refresh();
    }
    disconnectedCallback(){this.abort?.abort();clearTimeout(this.submitTimer);this.ready=false;}
    listen(target,event,fn){target.addEventListener(event,fn,{signal:this.abort.signal});}
    text(key){return this.labels[key]||key;}
    element(tag,text,cls){const e=document.createElement(tag);if(text)e.textContent=text;if(cls)e.className=cls;return e;}
    renderFamilies(){
      const host=this.querySelector('[data-families]');host.replaceChildren();
      for(const [key,varieties] of Object.entries(this.families)){
        const panel=this.element('section','', 'mw2-family');panel.dataset.familyPanel=key;panel.hidden=true;panel.append(this.element('h3',this.text(key)));
        for(const [type,values] of [['variety',varieties],['calibre',['segunda','primera','extra','super','jumbo']]]){
          const field=this.element('fieldset');field.append(this.element('legend',this.text(type==='variety'?'varieties':'calibres')));const choices=this.element('div','','mw2-options');
          for(const value of values){const label=this.element('label','','mw2-choice'),input=this.element('input');input.type='checkbox';input.dataset.family=key;input.dataset[type]='';input.value=value;label.append(input,this.element('span',this.text(value)));choices.append(label);}
          field.append(choices);panel.append(field);
        }
        const detail=this.element('details','','mw2-quantities');detail.append(this.element('summary',this.text('quantities')),this.element('p',this.text('quantity_help'),'mw2-guidance'));
        for(const variety of varieties){const group=this.element('details','','mw2-format');group.append(this.element('summary',this.text(variety)));
          for(const [calibre,units] of this.formats){const label=this.element('label','','mw2-quantity'),input=this.element('input');input.type='number';input.inputMode='numeric';input.min='0';input.max='999';input.step='1';input.placeholder='0';input.dataset.quantity='';input.dataset.family=key;input.dataset.varietyKey=variety;input.dataset.calibreKey=calibre;input.dataset.units=String(units);input.dataset.quantityId=[key,variety,calibre,units].join('_');input.setAttribute('aria-label',[this.text(key),this.text(variety),this.text(calibre),units,this.text('eggs'),this.text('boxes')].join(' · '));label.append(this.element('span',this.text(calibre)+' · '+units+' '+this.text('eggs')),input);group.append(label);}
          detail.append(group);
        }panel.append(detail);host.append(panel);
      }
    }
    activeKeys(){const line=this.querySelector('[data-line]:checked')?.value;return line==='ambas'?['industrial','libres']:this.families[line]?[line]:[];}
    chosen(key,type){return Array.from(this.querySelectorAll('[data-family="'+key+'"][data-'+type+']:checked')).map(e=>e.value);}
    quantities(){const keys=this.activeKeys();return Array.from(this.querySelectorAll('[data-quantity]')).filter(e=>keys.includes(e.dataset.family)&&e.validity.valid&&Number.isInteger(Number(e.value))&&Number(e.value)>0).map(e=>({family:e.dataset.family,variety:e.dataset.varietyKey,calibre:e.dataset.calibreKey,units:Number(e.dataset.units),q:Number(e.value)}));}
    summary(){const parts=[],raw=this.message.value.trim(),qty=this.quantities(),line=this.querySelector('[data-line]:checked')?.value;if(raw)parts.push(this.text('your_message')+':\n'+raw);if(line==='asesoria')parts.push(this.text('asesoria'));
      for(const key of this.activeKeys()){let part=this.text(key);for(const type of ['variety','calibre']){const chosen=this.chosen(key,type);if(chosen.length)part+='\n'+this.text(type==='variety'?'varieties':'calibres')+': '+chosen.map(v=>this.text(v)).join(', ');}for(const q of qty.filter(v=>v.family===key))part+='\n'+q.q+' '+this.text('boxes')+' · '+this.text(q.variety)+' · '+this.text(q.calibre)+' · '+q.units+' '+this.text('eggs');parts.push(part);}
      const volume=this.querySelector('[data-volume]:checked')?.value;if(volume&&volume!=='undefined')parts.unshift(this.text('tier_selected')+': '+this.text(volume));
      if(qty.length){const boxes=qty.reduce((sum,q)=>sum+q.q,0),eggs=qty.reduce((sum,q)=>sum+q.q*q.units,0);parts.push(this.text('total')+': '+boxes+' '+this.text('boxes')+' · '+new Intl.NumberFormat('es-CL').format(eggs)+' '+this.text('eggs'));if(boxes<4)parts.push(this.text('minimum_note'));const actual=this.detailTier();if(actual!=='undefined')parts.push(this.text('tier_detail')+': '+this.text(actual));if(volume&&volume!=='undefined'&&volume!==actual&&boxes>=4)parts.push(this.text('tier_mismatch'));}return parts.join('\n\n');
    }
    detailTier(){const boxes=this.quantities().reduce((sum,q)=>sum+q.q,0);return boxes>=51?'band3':boxes>=20?'band2':boxes>=4?'band1':'undefined';}
    contactMessage(){let text=this.text('wa_intro')+'\n\n'+(this.summary()||this.text('wa_general'));this.querySelectorAll('[data-contact]').forEach(e=>{if(e.value.trim())text+='\n'+this.text(e.dataset.contact)+': '+e.value.trim();});return text;}
    refresh(){const keys=this.activeKeys();this.querySelectorAll('[data-family-panel]').forEach(p=>p.hidden=!keys.includes(p.dataset.familyPanel));this.querySelectorAll('[data-quantity]').forEach(e=>e.disabled=!keys.includes(e.dataset.family));this.querySelector('[data-line-help]').hidden=keys.length>0;const summary=this.summary();this.querySelector('[data-tier-field]').value=this.text(this.querySelector('[data-volume]:checked')?.value||'undefined');this.querySelector('[data-detail-tier-field]').value=this.text(this.detailTier());this.querySelector('[data-summary]').textContent=summary||this.text('empty');this.bodyField.value=this.text('origin')+'\n\n'+summary+'\n\n'+this.text('no_charge');const url='https://wa.me/'+this.dataset.phone+'?text='+encodeURIComponent(this.contactMessage());this.querySelectorAll('[data-wa]').forEach(a=>a.href=url);}
    validQuantities(){const keys=this.activeKeys(),bad=Array.from(this.querySelectorAll('[data-quantity]')).find(e=>keys.includes(e.dataset.family)&&(e.validity.badInput||(e.value!==''&&(!Number.isInteger(Number(e.value))||Number(e.value)<0||Number(e.value)>999))));if(!bad)return true;this.error(this.text('quantity_error'));bad.closest('.mw2-format').open=true;bad.closest('.mw2-quantities').open=true;this.querySelector('[data-details]').open=true;bad.focus();return false;}
    error(text){const error=this.querySelector('[data-query-error]');error.textContent=text;error.hidden=false;}
    openForm(focus){this.contactPanel.hidden=false;this.querySelector('[data-open-form]').setAttribute('aria-expanded','true');if(focus)this.querySelector('[data-contact=name]').focus();this.save();}
    validPhone(){const phone=this.querySelector('[data-contact=phone]'),raw=phone.value.trim(),digits=raw.replace(/\D/g,'');let valid=!raw||(/^[+\d\s().-]+$/.test(raw)&&!/^(\d)\1+$/.test(digits));if(raw){if(raw.startsWith('+')&&!raw.startsWith('+56'))valid=valid&&/^[1-9]\d{7,14}$/.test(digits);else{const local=digits.startsWith('56')&&digits.length===11?digits.slice(2):digits;valid=valid&&/^[2-9]\d{8}$/.test(local);}}phone.setCustomValidity(valid?'':this.text('phone_error'));return valid;}
    validateInquiry(){
      if(!this.validQuantities())return false;
      if(!this.summary()){this.error(this.text('content_error'));this.message.focus();return false;}
      this.openForm(false);const name=this.querySelector('[data-contact=name]');name.setCustomValidity(name.value.trim()?'':this.text('name_error'));
      if(!this.validPhone())this.querySelector('.mw2-contact-optional').open=true;
      return this.form.reportValidity();
    }
    submit(event){
      if(this.submitting||!this.validateInquiry()){event.preventDefault();return;}
      this.refresh();this.save();const button=this.querySelector('[data-submit]'),status=this.querySelector('[data-status]');button.disabled=true;button.textContent=this.text('sending');status.hidden=false;status.textContent=this.text('pending');status.classList.remove('mw2-error');
      queueMicrotask(()=>{if(!event.defaultPrevented)this.submitting=true;});
      clearTimeout(this.submitTimer);this.submitTimer=setTimeout(()=>{this.resetSubmit();button.textContent=this.text('retry');status.hidden=false;status.textContent=this.text('timeout');status.classList.add('mw2-error');},30000);
    }
    resetSubmit(){this.submitting=false;clearTimeout(this.submitTimer);const button=this.querySelector('[data-submit]');if(button){button.disabled=false;button.textContent=this.text('send');}}
    save(){try{const data={version:3,time:Date.now(),message:this.message.value,line:this.querySelector('[data-line]:checked')?.value||'',volume:this.querySelector('[data-volume]:checked')?.value||'undefined',contacts:{},families:{},quantities:{},contactOpen:!this.contactPanel.hidden};this.querySelectorAll('[data-contact]').forEach(e=>data.contacts[e.dataset.contact]=e.value);for(const key of Object.keys(this.families))data.families[key]={varieties:this.chosen(key,'variety'),calibres:this.chosen(key,'calibre')};this.querySelectorAll('[data-quantity]').forEach(e=>{if(e.value!=='')data.quantities[e.dataset.quantityId]=e.value;});sessionStorage.setItem(this.dataset.key,JSON.stringify(data));}catch{}}
    restore(){try{const data=JSON.parse(sessionStorage.getItem(this.dataset.key)||'null');if(!data||![2,3].includes(data.version)||Date.now()-data.time>1800000){this.clearSaved();return;}this.message.value=String(data.message||'').slice(0,2000);this.querySelectorAll('[data-line]').forEach(e=>e.checked=e.value===data.line);this.querySelectorAll('[data-volume]').forEach(e=>e.checked=e.value===(data.version===3?data.volume:'undefined'));this.querySelectorAll('[data-contact]').forEach(e=>{const v=data.contacts?.[e.dataset.contact];if(typeof v==='string')e.value=v.slice(0,e.maxLength>0?e.maxLength:254);});for(const key of Object.keys(this.families))for(const type of ['variety','calibre'])this.querySelectorAll('[data-family="'+key+'"][data-'+type+']').forEach(e=>e.checked=(data.families?.[key]?.[type==='variety'?'varieties':'calibres']||[]).includes(e.value));this.querySelectorAll('[data-quantity]').forEach(e=>{const v=data.quantities?.[e.dataset.quantityId];if(typeof v==='string'&&v.length<8)e.value=v;});if(data.contactOpen)this.openForm(false);}catch{this.clearSaved();}}
    clearSaved(){try{sessionStorage.removeItem(this.dataset.key);}catch{}}
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["memys-wholesale"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('memys-wholesale')) {
    class MemysWholesale extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        this.on = (target, event, callback) => target.addEventListener(event, callback, { signal: this.controller.signal });
        try {
          this.config = JSON.parse(this.querySelector('[data-wholesale-config]').textContent);
        } catch { return; }
        const allowed = { segunda: [180], primera: [180], extra: [180], super: [100, 180], jumbo: [100] };
        this.catalog = this.config.catalog.filter(item => ['white','color','campo'].includes(item.variety) && allowed[item.calibre]?.includes(item.units));
        this.labels = this.config.labels;
        this.find = selector => this.querySelector(selector);
        this.n = value => new Intl.NumberFormat('es-CL').format(value);
        this.variety = this.find('[data-variety]');
        this.calibre = this.find('[data-calibre]');
        this.format = this.find('[data-format]');
        this.boxes = this.find('[data-boxes]');
        this.contact = this.find('.mw-contact');
        this.bodyField = this.find('[data-body]');
        this.lines = [];
        if (!this.catalog.length) return;
        this.classList.add('mw-enhanced');
        this.find('[data-builder]').hidden = false;
        this.find('[data-body-wrap]').hidden = true;
        this.bodyField.required = false;
        this.bodyField.readOnly = true;
        this.setOptions(this.variety, ['white','color','campo'].filter(v => this.catalog.some(p => p.variety === v)), this.labels.select, v => this.labels[v]);
        this.on(this.variety, 'change', () => this.updateCalibres());
        this.on(this.calibre, 'change', () => this.updateFormats());
        this.on(this.format, 'change', () => this.updateStock());
        this.on(this.find('[data-add]'), 'click', () => this.add());
        this.on(this.boxes, 'keydown', e => { if (e.key === 'Enter') { e.preventDefault(); this.add(); } });
        this.querySelectorAll('[data-choose]').forEach(link => this.on(link, 'click', () => {
          this.variety.value = link.dataset.choose;
          this.updateCalibres();
          this.calibre.focus({ preventScroll: true });
        }));
        this.on(this.contact, 'input', () => {
          this.find('[data-contact="phone"]').setCustomValidity('');
          this.updateMessage();
        });
        this.on(this.contact, 'change', () => this.updateMessage());
        this.on(this.contact, 'submit', event => {
          if (!this.lines.length) {
            event.preventDefault();
            this.showError('[data-form-error]', this.labels.empty_error);
            this.variety.focus();
            return;
          }
          const phone = this.find('[data-contact="phone"]');
          const digits = phone.value.replace(/\D/g, '');
          phone.setCustomValidity(digits.length < 8 || digits.length > 15 ? this.labels.phone_error : '');
          if (!this.contact.reportValidity()) { event.preventDefault(); return; }
          this.updateMessage();
          if (event.defaultPrevented) return;
          const button = this.find('[data-submit]');
          button.textContent = this.labels.sending;
          clearTimeout(this.resetTimer);
          this.resetTimer = window.setTimeout(() => this.resetSubmit(), 20000);
        });
        this.on(window, 'pageshow', () => this.resetSubmit());
        this.querySelectorAll('[data-whatsapp]').forEach(link => this.on(link, 'click', () => this.updateMessage()));
        const success = this.find('[data-success]');
        try {
          if (success) sessionStorage.removeItem(this.dataset.storageKey);
          else {
            const saved = JSON.parse(sessionStorage.getItem(this.dataset.storageKey) || 'null');
            if (saved && Date.now() - saved.time < 86400000 && Array.isArray(saved.lines)) {
              for (const line of saved.lines.slice(0, this.catalog.length)) {
                if (this.catalog.some(p => p.id === line.id) && this.validQuantity(line.quantity) && !this.lines.some(l => l.id === line.id)) this.lines.push({ id: line.id, quantity: line.quantity });
              }
            }
          }
        } catch {}
        this.paint();
        if (success) success.focus({ preventScroll: false });
        const serverError = this.find('[data-server-error]');
        if (serverError) serverError.focus({ preventScroll: false });
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        clearTimeout(this.resetTimer);
      }
      validQuantity(value) { return Number.isInteger(value) && value >= 1 && value <= 9999; }
      setOptions(select, values, placeholder, label) {
        select.replaceChildren();
        if (placeholder) select.add(new Option(placeholder, ''));
        for (const value of values) select.add(new Option(label ? label(value) : String(value), String(value)));
        select.disabled = !values.length;
      }
      updateCalibres() {
        const values = ['segunda','primera','extra','super','jumbo'].filter(v => this.catalog.some(p => p.variety === this.variety.value && p.calibre === v));
        this.setOptions(this.calibre, values, this.labels.select, v => this.labels[v]);
        this.setOptions(this.format, [], this.labels.choose_calibre_first);
        this.updateStock();
      }
      updateFormats() {
        const values = [...new Set(this.catalog.filter(p => p.variety === this.variety.value && p.calibre === this.calibre.value).map(p => p.units))].sort((a,b) => a-b);
        this.setOptions(this.format, values, values.length > 1 ? this.labels.select : null, v => v + ' ' + this.labels.units_per_box.toLowerCase());
        this.updateStock();
      }
      selected() { return this.catalog.find(p => p.variety === this.variety.value && p.calibre === this.calibre.value && p.units === Number(this.format.value)); }
      updateStock() {
        const item = this.selected();
        this.find('[data-stock]').textContent = item ? (item.available ? this.labels.stock_check : this.labels.stock_empty) : '';
      }
      showError(selector, message) {
        const target = this.find(selector);
        target.textContent = message;
        target.hidden = false;
      }
      add() {
        const item = this.selected();
        const quantity = Number(this.boxes.value);
        if (!item || !this.validQuantity(quantity)) {
          this.showError('[data-builder-error]', this.labels.builder_error);
          for (const field of [this.variety,this.calibre,this.format,this.boxes]) if (!field.disabled && !field.reportValidity()) break;
          return;
        }
        const existing = this.lines.find(line => line.id === item.id);
        if (existing && !this.validQuantity(existing.quantity + quantity)) { this.showError('[data-builder-error]', this.labels.quantity_error); return; }
        if (existing) existing.quantity += quantity;
        else this.lines.push({ id: item.id, quantity });
        this.find('[data-builder-error]').hidden = true;
        this.find('[data-form-error]').hidden = true;
        this.paint();
        this.find('[data-announcement]').textContent = this.labels.added;
      }
      paint() {
        const list = this.find('[data-lines]');
        list.replaceChildren();
        for (const line of this.lines) {
          const item = this.catalog.find(p => p.id === line.id);
          const row = document.createElement('li');
          row.className = 'mw-line';
          const description = document.createElement('div');
          const title = document.createElement('strong');
          title.textContent = this.labels[item.variety] + ' · ' + this.labels[item.calibre];
          const detail = document.createElement('small');
          detail.textContent = item.units + ' ' + this.labels.units_per_box.toLowerCase();
          description.append(title, detail);
          if (!item.available) { const stock = document.createElement('small'); stock.textContent = this.labels.stock_empty_short; description.append(stock); }
          const label = document.createElement('label');
          label.textContent = this.labels.quantity;
          const input = document.createElement('input');
          Object.assign(input, { type: 'number', min: '1', max: '9999', step: '1', value: String(line.quantity), inputMode: 'numeric' });
          input.setAttribute('aria-label', this.labels.boxes + ': ' + title.textContent + ', ' + item.units);
          label.append(input);
          this.on(input, 'input', () => {
            const value = Number(input.value);
            if (!this.validQuantity(value)) return;
            line.quantity = value;
            this.find('[data-builder-error]').hidden = true;
            this.updateTotals();
          });
          this.on(input, 'change', () => {
            const value = Number(input.value);
            if (!this.validQuantity(value)) {
              this.showError('[data-builder-error]', this.labels.quantity_error);
              input.value = String(line.quantity);
              return;
            }
            line.quantity = value;
            this.find('[data-builder-error]').hidden = true;
            this.updateTotals();
          });
          const remove = document.createElement('button');
          remove.type = 'button';
          remove.className = 'mw-remove';
          remove.textContent = '×';
          remove.setAttribute('aria-label', this.labels.remove + ': ' + title.textContent + ', ' + item.units);
          this.on(remove, 'click', () => {
            this.lines = this.lines.filter(l => l !== line);
            this.paint();
            this.find('[data-add]').focus({ preventScroll: true });
            this.find('[data-announcement]').textContent = this.labels.removed;
          });
          row.append(description, label, remove);
          list.append(row);
        }
        this.updateTotals();
      }
      updateTotals() {
        let boxes = 0, eggs = 0;
        for (const line of this.lines) {
          const product = this.catalog.find(p => p.id === line.id);
          boxes += line.quantity;
          eggs += line.quantity * product.units;
        }
        this.totalText = this.n(boxes) + ' ' + this.labels.total_boxes + ' · ' + this.n(eggs) + ' ' + this.labels.total_eggs;
        this.find('[data-totals]').textContent = this.totalText;
        this.find('[data-totals]').hidden = !this.lines.length;
        this.find('[data-empty]').hidden = !!this.lines.length;
        try { sessionStorage.setItem(this.dataset.storageKey, JSON.stringify({ time: Date.now(), lines: this.lines })); } catch {}
        this.updateMessage();
      }
      updateMessage() {
        const order = this.lines.map(line => {
          const item = this.catalog.find(p => p.id === line.id);
          return this.labels[item.variety] + ' · ' + this.labels[item.calibre] + ' · ' + item.units + ' huevos/caja · ' + this.n(line.quantity) + ' cajas' + (!item.available ? ' (' + this.labels.stock_empty_short + ')' : '');
        }).join('\n');
        this.bodyField.value = this.labels.request_origin + '\n\n' + order + '\n\n' + (this.lines.length ? this.totalText : '') + '\n' + this.labels.availability_note;
        let message = this.labels.wa_intro + '\n\n' + (this.lines.length ? order + '\n' + this.totalText : this.labels.wa_general);
        for (const key of ['name','business','phone','commune','email','frequency','delivery','notes']) {
          const value = this.find('[data-contact="' + key + '"]')?.value?.trim();
          if (value) message += '\n' + this.labels[key] + ': ' + value;
        }
        const url = 'https://wa.me/' + this.config.phone + '?text=' + encodeURIComponent(message);
        this.querySelectorAll('[data-whatsapp]').forEach(link => link.href = url);
      }
      resetSubmit() {
        this.submitting = false;
        const button = this.find('[data-submit]');
        button.disabled = false;
        button.textContent = this.labels.send + ' →';
        clearTimeout(this.resetTimer);
      }
    }
    customElements.define('memys-wholesale', MemysWholesale);
  }

  } catch(e) { console.error(e); }
})();
})();
